import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import useEmailValidation from "../../Global/Hooks/emailValidation";
import BackButton from "../../UI/BackButton";
import Button from "../../UI/Button";
import Input from "../../UI/Input";
import useForgotPasswordApi from "../../Global/Api/ForgotPassword/forgotPasswordApi";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const emailValidation = useEmailValidation();
  const forgotPasswordApi = useForgotPasswordApi();

  const isButtonDisabled = !emailValidation.isValid;

  const handleEmailChange = (event) => {
    emailValidation.handleChange(event);
    emailValidation.validateEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    forgotPasswordApi.send({ email: emailValidation.value });
  };

  useEffect(() => {
    if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
      navigate("/");
    }
  }, []);

  return (
    <RegisterWrapper image="/assets/images/register-2.svg">
      <BackButton />
      <h1 className="register__title mt20">Forgot password?</h1>
      <p className="register__p mt8">
        Enter the email address associated with your account and we will send
        you a link to reset your password.
      </p>
      <form onSubmit={handleSubmit} className="register__form">
        <div className="register__input mt20">
          <Input
            label="Email"
            placeholder="Enter email"
            type="email"
            id="email"
            value={emailValidation.value}
            handleChange={handleEmailChange}
          />
        </div>
        <div className="register__btn mt40">
          <Button
            text="Send a code"
            type="primary"
            disabled={isButtonDisabled}
            topPadding={12}
            bottomPadding={12}
          />
        </div>
      </form>
    </RegisterWrapper>
  );
}
